// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__36n3r","form":"styles_form__2M3qI"};